<script>
    import { setupI18n, _ } from './../i18n';

    export let inputValue = 999;
    export let minValue = 999;
    export let maxValue = 100001;
    export let labelText = $_('landing.followers')
    export let locale

    export let minValueText = '< 5 000';
    export let maxValueText = '> 100 000';

    export let inputTimeout = 500;

    let inputValueText = inputValue;
    function formatInputText() {
        if (inputValue <= minValue) {
            inputValueText = minValueText;
        } else if (inputValue >= maxValue) {
            inputValueText = maxValueText;
        } else {
            inputValueText = inputValue.toLocaleString('ru-RU');
        }
    }

    function increaseValue() {
        if (inputValue >= maxValue) {
            inputValue = maxValue;
        } else {
            inputValue += 1;
        }
    }
    function decreaseValue() {
        if (inputValue <= minValue) {
            inputValue = minValue;
        } else {
            inputValue -= 1;
        }
    }

    let formatInputTimeout = null;
    function onTextInput(event) {
        try {
            clearTimeout(formatInputTimeout);
        } catch (err) {}
        if (inputValueText !== '') {
            formatInputTimeout = setTimeout(function () {
                const value = (event.target.value).toString().replace(/\s/g, '').replace('<', '').replace('>', '');
                inputValue = Number(value);
                formatInputText();
            }, inputTimeout);
        }
    }

    $: inputValue && formatInputText();
</script>

<div class="input-wrap">

    <div class="input">
        <input type="text" bind:value={inputValueText} on:input={onTextInput} class={'input_' + locale}/>
        <div class={"controls-wrap controls-wrap-" + locale}>
            <a class="arrow-up-wrap arrow-wrap" on:click={increaseValue}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 10 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="18 15 12 9 6 15"/>
                </svg>
            </a>
            <a class="arrow-down-wrap arrow-wrap" on:click={decreaseValue}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 10 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"/>
                </svg>
            </a>
        </div>
    </div>
    <div class={"label-" + locale}>{labelText}</div>

</div>

<style>
    .label-en-US {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        text-align: center;
        color: #23173D;
    }
    .label-ru-RU {
        color: #23173D;
        text-align: center;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .input-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -25px;
    }
    .input-wrap .input {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 91px;
        height: 31px;
        border: 1px solid #E8E8E8;
        border-radius: 8px;
        text-align: center;
        margin-right: 10px;
        padding: 0 4px 0 10px;
    }
    .input .controls-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .input .controls-wrap-en-US {
        margin-top: -7px;
        margin-right: 3px;
    }
    .input .controls-wrap-ru-RU {
        margin-top: -5px;
        margin-right: 10px;
    }
    .controls-wrap .arrow-wrap {
        width: 12px;
        height: 12px;
    }
    .input input {
        max-width: 100%;
        border: none;
        text-align: center;
        line-height: 25px;
    }
    .input_ru-RU {
        color: #23173D;
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal !important;
        max-width: 80% !important;
    }
    .input input:focus {
        outline: none;
    }
</style>